<template>
  <div class="child2">
    <el-form
            ref="form"
            :model="form"
            label-width="10px"
            size="small"
    >
      <el-form-item
      >
        提现明细
        <el-divider></el-divider>
      </el-form-item>
      <el-form-item
      >
  <el-table
          :data="tableData"
          v-loading="loading"
          size="small"
          stripe
          highlight-current-row
          style="width: 100%;"
          @selection-change="handleSelectionChange"
          @sort-change="handleSortChange"
  >

    <el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50px">
    </el-table-column>
    <el-table-column
            label="姓名"
    >
      <template slot-scope="scope">
        {{scope.row.one_agent_name}}
      </template>
    </el-table-column>


    <el-table-column
            label="提现成功金额"
    >
      <template slot-scope="scope">
        {{scope.row.order_amount}}
      </template>
    </el-table-column>
    <el-table-column
            label="提现成功数"
    >
      <template slot-scope="scope">
        {{scope.row.order_num}}
      </template>
    </el-table-column>
    <el-table-column
            label="提现失败金额"
    >
      <template slot-scope="scope">
        {{scope.row.refund_amount}}
      </template>
    </el-table-column>
    <el-table-column
            label="提现失败数"
    >
      <template slot-scope="scope">
        {{scope.row.refund_num}}
      </template>
    </el-table-column>

    <el-table-column
            label="操作"
            width="200"
    >
      <template slot-scope="scope">

        <el-button type="primary" plain  size="mini"    @click="openViewForm2(scope.row)">详情</el-button>


      </template>
    </el-table-column>


  </el-table>
  <div style="text-align: center;margin-top: 30px;">
    <el-pagination
            :current-page="page.current"
            :page-size="page.size"
            :total="page.total"
            :page-sizes="[1,10,50,100, 200, 300, 400]"
            layout="total, sizes, prev, pager, next, jumper"
            style="margin: -10px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>

      </el-form-item>

    </el-form>

  </div>

</template>

<script>
import * as agentService from "@/api/sys/agent";

import util from '@/libs/util.js'
export default {
  name: "PayTurnover",
  data() {
    return {
        loading: false,
        start_time:'',
        end_time:'',
        userName:'',
        form: {},
        tableData: [],
        multipleSelection: [],
        page: {
            current: 1,
            size: 10,
            total: 0
        },
        sort: {
            prop: "",
            order: ""
        }
    };
  },
    mounted() {

      //  console.log("========");
        //this.getTableData();
    },
  methods: {
      openViewForm2(agent){
          this.$emit('refreshTurnover',agent.one_agent_id);
      },

      getTableData() {
          let query = {
              pageIndex: this.page.current,
              pageSize: this.page.size,
              sortBy: this.sort.prop,
              agentid: util.cookies.get('agentid'),
              dl_type: util.cookies.get('dl_type'),
              xt_id: util.cookies.get('xt_id'),
          start_time:this.start_time,
              end_time:this.end_time,
            drawname:this.userName,
              descending: this.sort.order === "descending"
          };
          agentService.getTxOrderPagedlist(query).then(data => {
              this.tableData = data.rows;
              this.page.total = data.totalCount;
          });
      },
      handleSearchFormSubmit() {
          this.getTableData();
      },
      handleSearchFormReset() {
          this.$refs.searchForm.resetFields();
      },
      handleSelectionChange(val) {
          this.multipleSelection = val;
      },
      handleSortChange(val) {
          this.sort.prop = val.prop;
          this.sort.order = val.order;
          this.getTableData();
      },
      handleSizeChange(val) {
          this.page.size = val;
          this.getTableData();
      },
      handleCurrentChange(val) {
          this.page.current = val;
          this.getTableData();
      }
  }
};
</script>


